import { OKTA_OIDC_INITIALIZE, OKTA_OIDC_SIGN_IN, SIGN_OUT, SET_ERROR, SET_USER_PERMISSION } from './constants'

import { PermissionAPI, getUserPermissions, getUserPermissionsWithAuth } from '@/api'

const actions = {
  async [OKTA_OIDC_INITIALIZE](context, { auth, user }) {
    if (!context.state.oidcAuth) {
      let accessToken = await auth.getAccessToken()
      context.commit(OKTA_OIDC_SIGN_IN, { accessToken, username: user.email })
      getUserPermissionsWithAuth().then(resp => {
        context.commit(SET_USER_PERMISSION, resp.data)
      })
    }
  },
  [SIGN_OUT](context) {
    context.commit(SIGN_OUT)
  },
  [SET_ERROR](context, error) {
    context.commit(SET_ERROR, error)
  },
  [SET_USER_PERMISSION](context) {
    getUserPermissions().then(resp => {
      context.commit(SET_USER_PERMISSION, resp.data)
    })
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/actions.js